var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar organización"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Nuevo aspecto")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("aspectos-form", { on: { submit: _vm.submit } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }